var React = require('react');

function CheckboxFalseInline (overrides) {
const props = Object.assign({}, {"viewBox":"0 0 24 24","fill":"none"}, overrides);
    return React.createElement("svg",props,React.createElement("rect",{"x":".5","y":".5","width":"23","height":"23","rx":"3.5","stroke":"currentColor"}));
}

module.exports = CheckboxFalseInline;

CheckboxFalseInline.default = CheckboxFalseInline;
